import { render, staticRenderFns } from "./ReportAbsentIndex.vue?vue&type=template&id=45cd5408"
import script from "./ReportAbsentIndex.vue?vue&type=script&lang=js"
export * from "./ReportAbsentIndex.vue?vue&type=script&lang=js"
import style0 from "./ReportAbsentIndex.vue?vue&type=style&index=0&id=45cd5408&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports